module.exports = __webpack_public_path__ + "470dc6a3ee4054e3ded6a3eaf3973018.ttf";